// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"68e6ab97","759":"9f3573b1"}[chunkId] + ".chunk.css";
};